let promise = null

export default ({ Vue }) => {
    let url_main = 'statics/jwplayer.js'

    Vue.prototype.$jwplayer = function () {
        if (!promise) {
            promise = new Promise((resolve, reject) => {
                let script_main = document.createElement('script')
                script_main.async = true
                script_main.type = 'application/javascript'
                script_main.src = url_main

                script_main.onload = () => {
                    resolve()
                }
                script_main.onerror = (err) => {
                    reject(err)
                }

                document.body.appendChild(script_main)
            })
        }

        return promise
    }
}